var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 16.6667C4.375 16.3215 4.65482 16.0417 5 16.0417L15 16.0417C15.3452 16.0417 15.625 16.3215 15.625 16.6667C15.625 17.0119 15.3452 17.2917 15 17.2917L5 17.2917C4.65482 17.2917 4.375 17.0119 4.375 16.6667Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55806 2.8914C9.80214 2.64732 10.1979 2.64732 10.4419 2.8914L13.3586 5.80807C13.6027 6.05215 13.6027 6.44787 13.3586 6.69195C13.1145 6.93603 12.7188 6.93603 12.4747 6.69195L10.625 4.84223V13.3333C10.625 13.6785 10.3452 13.9583 10 13.9583C9.65482 13.9583 9.375 13.6785 9.375 13.3333V4.84223L7.52527 6.69195C7.2812 6.93603 6.88547 6.93603 6.64139 6.69195C6.39731 6.44787 6.39731 6.05215 6.64139 5.80807L9.55806 2.8914Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a215ea96fa0588ea87ae5f6293094f69.svg";
export { ForwardRef as ReactComponent };